export default {
  // Introduce Row
  'dashboard.analysis.total-sales': 'Total GGR',
  'dashboard.analysis.visits': 'Total Login Today',
  'dashboard.analysis.payments': 'Active Owners',
  'dashboard.analysis.operational-effect': 'System Health',
  'dashboard.analysis.indicator-introduction': 'Indicator Introduction',
  'dashboard.analysis.active-players': 'Active Players',
  'dashboard.analysis.daily-players': 'Daily Players',
  'dashboard.analysis.turnover': 'Turnover',
  'dashboard.analysis.week-on-week': 'Week on Week',
  'dashboard.analysis.day-on-day': 'Day on Day',

  // Sales Card
  'dashboard.analysis.ggr-by-provider': 'Gross Revenue By Provider',
  'dashboard.analysis.visits-ranking': 'Visits Ranking',
  'dashboard.analysis.ggr-by-provider-ranking': 'Our Top Provider Ranking',
  'dashboard.analysis.all-day': 'Today',
  'dashboard.analysis.all-week': 'This Week',
  'dashboard.analysis.all-month': 'This Month',
  'dashboard.analysis.all-year': 'This Year',
  "pages.playerFinanceOperations.title": "Processing Transactions",

  'dashboard.analysis.week': 'Week',
  'dashboard.analysis.month': 'Month',
  'dashboard.analysis.year': 'Year',

  // Top Search -> Top Vendors
  'dashboard.analysis.online-top-search': 'Top Game Vendors',
  'dashboard.analysis.search-users': 'Total Games',
  'dashboard.analysis.per-capita-search': 'Avg Game Import',
  'dashboard.analysis.table.rank': 'Rank',
  'dashboard.analysis.table.search-keyword': 'Vendor Name',
  'dashboard.analysis.table.users': 'Game Count',
  'dashboard.analysis.table.weekly-range': 'Growth Rate',
  'pages.org.hierarchy.site': 'Network',

  // Proportion Sales
  'dashboard.analysis.the-proportion-of-sales': 'Platform Composition',
  'dashboard.analysis.channel.all': 'Site Stages',
  'dashboard.analysis.channel.online': 'Game Types',
  'dashboard.analysis.channel.stores': 'Currencies',

  // Offline Data
  'dashboard.analysis.offline-data': 'Owner Quality',
  'dashboard.analysis.conversion-rate': 'Production CVR',

  'monitor.trading.title': 'Real-time Transaction Status',
  'monitor.trading.total-turnover': 'Total Turnover Today',
  'monitor.trading.target-completion': 'Daily Target Completion',
  'monitor.trading.time-remaining': 'Time Remaining',
  'monitor.trading.live-tps': 'Live TPS',

  'monitor.trend.traffic': 'Live Traffic',
  'monitor.rtp.title': 'Live RTP % (House Edge)',
  'monitor.rtp.status.profitable': 'Profitable',
  'monitor.rtp.status.risk': 'High Risk',
  'monitor.rtp.status.critical': 'CRITICAL LOSS',

  'monitor.category.proportion': 'Game Type Proportion',
  'monitor.category.top-ranks': 'Ranking',
  'monitor.category.none': 'All',
  'monitor.category.electronic': 'Electronic',
  'monitor.category.slot': 'Slots',
  'monitor.category.table': 'Table Games',
  'monitor.category.live': 'Live Casino',
  'monitor.category.lottery': 'Lottery',
  'monitor.category.fish': 'Fish Hunter',
  'monitor.category.arcade': 'Arcade',
  'monitor.category.sport': 'Sport',
  'monitor.category.esport': 'E-sport',

  'pages.header.selectSite': 'Site',

  'vendor.ggr.card.category.none': 'ทั้งหมด',
  'vendor.ggr.card.category.electronic': 'Electronic',
  'vendor.ggr.card.category.slot': 'Slots',
  'vendor.ggr.card.category.table': 'Table Games',
  'vendor.ggr.card.category.live': 'Live Casino',
  'vendor.ggr.card.category.lottery': 'Lottery',
  'vendor.ggr.card.category.fish': 'Fish Hunter',
  'vendor.ggr.card.category.arcade': 'Arcade',
  'vendor.ggr.card.category.sport': 'Sport',
  'vendor.ggr.card.category.esport': 'E-sport',
  'pages.header.switchingSite': 'Switching site...',
  'pages.layouts.userLayout.title': 'Version 1.0.0',
  'pages.login.accountLogin.tab': 'Member Area',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.username.placeholder': 'Member ID / Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.totp.placeholder': '2FA Authenticator',
  'pages.login.hubOwnerLogin.tab': 'Gateway Owner Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.name': 'Name',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Rule Title',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.search': 'Search',
  'pages.searchTable.reset': 'Reset',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'ITABLES',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.nameAccountStatus.sandbox': 'แซนด์บ็อกซ์',
  'pages.searchTable.nameAccountStatus.production': 'โปรดักชัน',
  'pages.searchTable.nameAccountStatus.ban': 'แบน',
  'pages.searchTable.nameAccountStatus.pause': 'ระงับชั่วคราว',

  'pages.common.currencyNotSupported': 'Not supported player\'s currency.',

  "pages.vendor.ggr.card.day": "Day",
  "pages.vendor.ggr.card.fees.maintenance": "Maintenance Fees",
  "pages.vendor.ggr.card.fees.service": "Service Fees",

  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.id': 'ID',
  'pages.searchTable.balance': 'Balance',
  'pages.searchTable.batchDeletion': 'Batch Deletion',
  'pages.searchTable.batchApproval': 'Batch Approval',
  'dashboard.analysis.weekly-comparison': 'Weekly',
  'dashboard.analysis.daily-comparison': 'Daily',
  'dashboard.analysis.daily-sales': 'GGR/Daily',
  'dashboard.analysis.new-sites': 'Total Logins',
  'dashboard.analysis.daily-visits': 'Logins/Daily',
  // Profile Basic
  'pages.profile.basic.time': 'Time',
  'pages.profile.basic.rate': 'Current Progress',
  'pages.profile.basic.status': 'Status',
  'pages.profile.basic.status.success': 'Success',
  'pages.profile.basic.status.processing': 'Processing',
  'pages.profile.basic.operator': 'Operator ID',
  'pages.profile.basic.cost': 'Cost',
  'pages.profile.basic.total': 'Total',
  'pages.profile.basic.good.id': 'Good ID',
  'pages.profile.basic.good.name': 'Good Name',
  'pages.profile.basic.good.barcode': 'Good Barcode',
  'pages.profile.basic.good.price': 'Price',
  'pages.profile.basic.good.num': 'Quantity',
  'pages.profile.basic.good.amount': 'Amount',
  'pages.profile.basic.refund': 'Refund Request',
  'pages.profile.basic.pickup.number': 'Pickup Number',
  'pages.profile.basic.pickup.status': 'Pickup Status',
  'pages.profile.basic.pickup.status.picked': 'Picked',
  'pages.profile.basic.sale.number': 'Sale Number',
  'pages.profile.basic.child.order': 'Child Order',
  'pages.profile.basic.user.info': 'User Information',
  'pages.profile.basic.user.name': 'User Name',
  'pages.profile.basic.user.phone': 'Contact Phone',
  'pages.profile.basic.user.express': 'Express',
  'pages.profile.basic.user.address': 'Pickup Address',
  'pages.profile.basic.user.remark': 'Remark',
  'pages.profile.basic.user.remark.none': '-',
  'pages.profile.basic.return.goods': 'Return Goods',
  'pages.profile.basic.return.progress': 'Return Progress',

  'pages.player.list': 'Player List',
  'pages.player.list.title': 'Player List',
  'pages.player.list.id': 'ID',
  'pages.player.list.playerInfo': 'Player Info',
  'pages.player.list.balance': 'Balance',
  'pages.player.drawer.phoneRequired': 'Phone Requires',
  'pages.player.list.ggr': 'GGR',
  'pages.player.list.affiliate': 'Affiliate',
  'pages.player.list.createdAt': 'Created At',
  'pages.player.list.actions': 'Actions',
  'pages.player.list.transfer': 'Transfer',
  'pages.player.list.sendSMS': 'Send SMS',
  'pages.player.list.delete': 'Delete',
  'pages.player.list.verified_phone': 'Verified Phone',
  'pages.player.list.ggrTooltip':
    'Gross Gaming Revenue (Total Bet - Total Win)',
  'pages.player.list.deleteConfirm': 'Confirm delete?',
  'pages.player.list.total': 'Total {total} items',
  'pages.player.new': 'Bonus New Player',
  'pages.player.modal.title': 'Register New Player',
  'pages.player.modal.tryRefreshSitesFirst': 'Try refresh sites first',
  'pages.player.modal.site': 'Site',
  'pages.player.modal.currency': 'Currency',
  'pages.player.modal.close': 'Close',
  'pages.player.modal.register': 'Register New Player',
  'pages.player.modal.verify': 'Verify New Player',
  'pages.player.modal.back': 'Back',
  'pages.player.modal.verify.otp': 'Verify New Player',
  'pages.player.modal.passwordInfo': 'Information about account password',
  'pages.player.modal.passwordInfoSubtitle':
    "The password is generated automatically based on the phone number and will be sent to the player's phone number.",

  'pages.common.save': 'Save',
  'pages.common.create': 'Create',
  'pages.common.cancel': 'Cancel',
  'pages.common.notfound': 'Resource not exist',
  // Profile Advanced
  'pages.profile.advanced.op1': 'Operation One',
  'pages.profile.advanced.op2': 'Operation Two',
  'pages.profile.advanced.op3': 'Operation Three',
  'pages.profile.advanced.main.op': 'Main Operation',
  'pages.profile.advanced.opt1': 'Option One',
  'pages.profile.advanced.opt2': 'Option Two',
  'pages.profile.advanced.opt3': 'Option Three',
  'pages.profile.advanced.log1': 'Operation Log One',
  'pages.profile.advanced.log2': 'Operation Log Two',
  'pages.profile.advanced.log3': 'Operation Log Three',
  'pages.profile.advanced.type': 'Operation Type',
  'pages.profile.advanced.operator': 'Operator',
  'pages.profile.advanced.result': 'Result',
  'pages.profile.advanced.result.success': 'Success',
  'pages.profile.advanced.result.reject': 'Reject',
  'pages.profile.advanced.time': 'Operation Time',
  'pages.profile.advanced.memo': 'Memo',
  'pages.profile.advanced.status': 'Status',
  'pages.profile.advanced.status.pending': 'Pending',
  'pages.profile.advanced.amount': 'Order Amount',
  'pages.profile.advanced.creator': 'Creator',
  'pages.profile.advanced.product': 'Ordered Product',
  'pages.profile.advanced.create.time': 'Create Time',
  'pages.profile.advanced.rel.doc': 'Related Document',
  'pages.profile.advanced.effect.date': 'Effective Date',
  'pages.profile.advanced.remind': 'Please confirm within two working days',
  'pages.profile.advanced.urge': 'Urge',
  'pages.profile.advanced.no.response': 'No Response',
  'pages.profile.advanced.cost': 'Cost: ',
  'pages.profile.advanced.hours': ' hours ',
  'pages.profile.advanced.minutes': ' minutes',
  'pages.profile.advanced.detail': 'Details',
  'pages.profile.advanced.rule': 'Rules',
  'pages.profile.advanced.order.no': 'Order Number: ',
  'pages.profile.advanced.flow': 'Flow Progress',
  'pages.profile.advanced.step1': 'Create Project',
  'pages.profile.advanced.step2': 'Department Preliminary Review',
  'pages.profile.advanced.step3': 'Financial Review',
  'pages.profile.advanced.step4': 'Finish',
  'pages.profile.advanced.user.info': 'User Information',
  'pages.profile.advanced.user.name': 'User Name',
  'pages.profile.advanced.user.card': 'Member Card Number',
  'pages.profile.advanced.user.id': 'ID Card',
  'pages.profile.advanced.user.phone': 'Contact Information',
  'pages.profile.advanced.user.address': 'Contact Address',
  'pages.profile.advanced.info.group': 'Information Group',
  'pages.profile.advanced.data': 'Some Data',
  'pages.profile.advanced.update.time': 'Data Update Time',
  'pages.profile.advanced.data.desc': 'Data Description',
  'pages.profile.advanced.multi.group': 'Multi-level Information Group',
  'pages.profile.advanced.group.name': 'Group Name',
  'pages.profile.advanced.manager': 'Manager',
  'pages.profile.advanced.role': 'Role Code',
  'pages.profile.advanced.dept': 'Department',
  'pages.profile.advanced.expire': 'Expiration Time',
  'pages.profile.advanced.desc': 'Description',
  'pages.profile.advanced.scientific.name': 'Scientific Name',
  'pages.profile.advanced.call.records': 'User Call Records (past six months)',
  'pages.profile.advanced.creator.val': 'Qu Lili',
  'pages.profile.advanced.product.val': 'XX Service',
  'pages.profile.advanced.username.zhou': 'Zhou Maomao',
  'pages.profile.advanced.username.wu': 'Wu Jiahao',
  'pages.profile.advanced.username.lin': 'Lin Dongdong',
  'pages.profile.advanced.user.name.val': 'Fu Xiaoxiao',
  'pages.profile.advanced.user.address.val':
    'Qu Lili 18100000000 Intersection of Huanggu Mountain Road and Gongzhuan Road, Xihu District, Hangzhou, Zhejiang Province',
  'pages.profile.advanced.dept.val': 'XX Company - YY Department',
  'pages.profile.advanced.desc.val':
    'This description is very long very long very long very long...',
  'pages.profile.advanced.scientific.name.val':
    'Citrullus lanatus (Thunb.) Matsum. et Nakai is an annual trailing vine; its stems and branches are thick and prominently ribbed. The tendrils are thick...',
  'pages.profile.basic.total.id': 'Total',
  'pages.profile.basic.user.name.val': 'Fu Xiaoxiao',
  'pages.profile.basic.user.express.val': 'Cainiao Storage',
  'pages.profile.basic.user.address.val':
    'No. 18 Wantang Road, Xihu District, Hangzhou, Zhejiang Province',
  'pages.management.transactions.betAmount': 'Bet',
  'pages.management.transactions.payoutAmount': 'Payout',
  'pages.management.transactions.targetCompletion': 'Daily Target Completion',
  'pages.management.transactions.timeRemaining': 'Time Remaining',
  'pages.management.transactions.liveTps': 'Live TPS',
  'pages.management.transactions.reqPerSec': 'Req/Sec',
  'pages.management.transactions.total': 'Total {total}',

  'pages.gateway.name': 'Name',
  // Control Center
  'pages.controlCenter.title': 'Control Center',
  'pages.controlCenter.description':
    'Manage your AI services and resource allocations',
  'pages.controlCenter.mode': '{mode}',
  'pages.controlCenter.sandbox': 'Sandbox',
  'pages.controlCenter.seamless': 'Seamless',
  'pages.game.badges.new': 'New',
  'pages.game.badges.top-rated': 'Top Rated',
  'pages.game.badges.hot': 'Hot',
  'pages.game.edit': 'Update Game',
  'pages.controlCenter.syncHubs': 'Sync All Hubs',
  'pages.controlCenter.saveConfig': 'Save Config',
  'pages.controlCenter.balance': 'Account Balance',
  'pages.controlCenter.site_balance': 'Site Value',
  'pages.controlCenter.site_balance_virtual_complimentary': 'Virtual Complimentary',
  'pages.controlCenter.creditType': 'Credit Type',
  'pages.controlCenter.activeHubs': 'Active Hubs',
  'pages.controlCenter.online': 'ONLINE',
  'pages.controlCenter.ownerName': 'Owner Name',
  'pages.controlCenter.id': 'ID',
  'pages.controlCenter.memberStatus': 'Enviroment Status',
  'pages.controlCenter.ownerNotFound': 'Owner information not found',
  'pages.controlCenter.configSaved': 'Configuration saved',
  'pages.controlCenter.syncFailed': 'Failed to request hub synchronization',
  'pages.controlCenter.noHubsFound': 'No hubs found to synchronize',
  'pages.controlCenter.syncAccepted':
    'Gateway synchronization request accepted',
  'pages.controlCenter.robots.dazing.title':
    'DazingLottie - Breathing + Blinking',
  'pages.controlCenter.robots.dazing.desc':
    'Use the Lottie animation library to provide a breathing + blinking animation effect',
  'pages.controlCenter.robots.thinking.title':
    'ThinkingLottie - Blinking + Running',
  'pages.controlCenter.robots.thinking.desc':
    'Use the Lottie animation library to provide a blinking + running animation effect',
  'pages.controlCenter.robots.bouncing.title': 'BouncingLottie - Bouncing',
  'pages.controlCenter.robots.bouncing.desc':
    'Use the Lottie animation library to provide a bouncing animation effect',
  'pages.controlCenter.robots.blowing.title':
    'BlowingWindLottie - Blowing Wind',
  'pages.controlCenter.robots.blowing.desc':
    'Use the Lottie animation library to provide a blowing wind animation effect',
  'pages.controlCenter.robots.peek.title': 'PeekLottie - Peek',
  'pages.controlCenter.robots.peek.desc':
    'Use the Lottie animation library to provide a peek animation effect',

  // XUDO Common
  'pages.xudo.deleteSuccess': 'Deleted successfully and will refresh soon',
  'pages.xudo.deleteFailed': 'Delete failed, please try again',
  'pages.xudo.addSuccess': 'Added successfully',
  'pages.xudo.addFailed': 'Adding failed, please try again!',
  'pages.xudo.updateSuccess': 'Updated successfully',
  'pages.xudo.updateFailed': 'Update failed, please try again',
  'pages.xudo.pleaseSelectItems': 'Please select items to delete',
  'pages.xudo.game.selectGame': 'Please select a game',
  'pages.xudo.search.placeholder': 'Search {field}',
  'pages.xudo.filter': 'Filter',
  'pages.xudo.close': 'Close',
  'pages.xudo.total': 'Total {total}',
  'pages.xudo.profile': 'Profile',

  // Game Column Status
  'pages.games.online': 'Online',
  'pages.games.maintenanceStatus': 'Maintenance',
  'pages.games.play': 'Play',

  // Vendor Page
  'pages.vendor.title': 'Vendor List',
  'pages.vendor.new': 'New Vendor',
  'pages.vendor.updateTitle': 'Vendor Configuration',
  'pages.vendor.vendor': 'Vendor',
  'pages.vendor.code': 'Code',
  'pages.vendor.gateway_id': 'Gateway ID',
  'pages.vendor.status': 'Status',
  'pages.vendor.status.sandbox': 'Sandbox',
  'pages.vendor.status.production': 'Production',
  'pages.vendor.status.ban': 'Ban',
  'pages.vendor.status.maintenance': 'Maintenance',
  'pages.vendor.updatedAt': 'Updated At',
  'pages.vendor.operating': 'Operating',
  'pages.vendor.codeRequired': 'Vendor Code is required',
  'pages.vendor.codeLabel': 'Vendor Code',
  'pages.vendor.hubIdRequired': 'Gateway ID is required',
  'pages.vendor.hubIdLabel': 'Gateway ID',
  'pages.vendor.statusLabel': 'Status',
  'pages.vendor.category': 'Category',
  'pages.vendor.currencies': 'Supported Currencies',
  'pages.vendor.configSupported': 'Configuration Supported',
  'pages.vendor.yes': 'Yes',
  'pages.vendor.no': 'No',
  'pages.vendor.localizedLabels': 'Localized Labels',
  'pages.vendor.defaultSettings': 'Default Settings',
  'pages.vendor.images': 'Vendor Images',
  'pages.vendor.syncAllGame': 'Sync All Game',
  'pages.vendor.syncSuccess': 'Synced {vendors} vendors. {games} games are available from Hub.',
  'pages.vendor.syncFailed': 'Sync failed',
  'pages.vendor.id': 'ID',
  'pages.vendor.org_id': 'Organization ID',
  'pages.vendor.sandbox_currency': 'Sandbox Currency',
  'pages.vendor.maintenance_at': 'Maintenance At',
  'pages.vendor.categoryPlaceholder': 'Select or type categories',
  'pages.vendor.notes': 'Notes',

  // Gateway Page
  'pages.gateway.title': 'Gateway List',
  'pages.gateway.new': 'New Gateway',
  'pages.gateway.updateTitle': 'Gateway Configuration',
  'pages.gateway.id': 'ID',
  'pages.gateway.code': 'Code',
  'pages.gateway.codeRequired': 'Gateway code is required',
  'pages.gateway.stage': 'Stage',
  'pages.gateway.stage.sandbox': 'Sandbox',
  'pages.gateway.stage.production': 'Production',
  'pages.gateway.status': 'Status',
  'pages.gateway.status.active': 'Active',
  'pages.gateway.status.inactive': 'Inactive',
  'pages.gateway.currencies': 'Currencies',
  'pages.gateway.updatedAt': 'Updated At',
  'pages.gateway.operating': 'Operating',
  'pages.gateway.syncAll': 'Synchronize All',
  'pages.gateway.sync': 'Synchronize',
  'pages.gateway.syncSuccess': 'Synchronization started successfully',
  'pages.gateway.syncFailed':
    'Synchronization failed to start, please try again',
  'pages.gateway.connectionConfig': 'Connection Config',
  'pages.gateway.advancedConfig': 'Advanced Config',

  // Game Page
  'pages.game.title': ' ',
  'pages.game.id': 'ID',
  'pages.game.maintenance': 'System',
  'pages.game.uat': 'Latest at',
  'pages.game.cat': 'Added at',

  'pages.game.new': 'New Game',
  'pages.game.updateTitle': 'Game Configuration',
  'pages.game.basicInfo': 'Basic Information',
  'pages.game.game': 'Game',
  'pages.game.code': 'Code',
  'pages.game.vendorId': 'Vendor ID',
  'pages.game.category': 'Category',
  'pages.game.category.all': 'All',
  'pages.game.category.none': 'ทั้งหมด',
  'pages.game.category.blockchain': 'Blockchain',
  'pages.game.category.electronic': 'Electronic',
  'pages.game.category.slot': 'Slot',
  'pages.game.category.table': 'Table',
  'pages.game.category.live': 'Live',
  'pages.game.category.lottery': 'Lottery',
  'pages.game.category.fish': 'Fish',
  'pages.game.category.arcade': 'Arcade',
  'pages.game.category.sport': 'Sport',
  'pages.game.category.esport': 'E-Sport',
  'pages.games.vendor': 'Vendor',
  'pages.games.maintenance': 'Maintenance',
  'pages.game.set-rtp': 'Set RTP',
  'pages.game.officialStatus': 'Official Status',
  'pages.game.status.active': 'Active',
  'pages.game.status.inactive': 'Inactive',
  'pages.game.status.maintenance': 'Maintenance',
  'pages.game.status.online': 'Online',
  'pages.game.updatedAt': 'Updated At',
  'pages.game.operating': 'Operating',
  'pages.game.play': 'Play',
  'pages.game.rtp': 'RTP',
  'pages.game.rtpConfig': 'RTP Configuration - {name} ({id})',
  'pages.game.rtpLabel': 'Return to Player (RTP) %',
  'pages.game.rtpUpdateSuccess': 'RTP updated successfully',
  'pages.game.rtpUpdateFailed': 'Failed to update RTP',
  'pages.game.rtpFetchFailed': 'Failed to fetch RTP',
  'pages.game.update': 'Update',
  'pages.game.launch': 'Launch Game',
  'pages.game.launchFailed': 'Failed to launch game',
  'pages.game.launchUrlFailed': 'Failed to get launch URL',
  'pages.game.noGameSelected': 'No game selected',
  'pages.game.gameDataNotFound': 'Game data not found',
  'pages.game.playerTokenNotFound': 'Player access token not found',
  'pages.game.missingData': 'Game code or vendor is missing',
  'pages.game.codeRequired': 'Game Code is required',
  'pages.game.vendorRequired': 'Vendor is required',
  'pages.game.labels': 'Localized Labels',
  'pages.game.settings': 'Official Settings',
  'pages.game.images': 'Game Images',

  // Owner Page
  'pages.owner.title': 'Owner List',
  'pages.owner.new': 'New Owner',
  'pages.owner.owner': 'Owner',
  'pages.owner.name': 'Owner Name',
  'pages.owner.nameRequired': 'Owner name is required',
  'pages.owner.updateTitle': 'Owner Configuration',
  'pages.owner.budgetConfig': 'Budget Configuration',
  'pages.owner.balance': 'Balance',
  'pages.owner.creditType': 'Credit Type',
  'pages.owner.creditType.seamless': 'Seamless',
  'pages.owner.creditType.prepaid': 'Prepaid',
  'pages.owner.currency': 'Currency',
  'pages.owner.initialLogin': 'Initial Login',
  'pages.owner.lastActiveTime': 'Last Active Time',
  'pages.owner.orgSection': 'Organization Information',
  'pages.owner.orgName': 'Organization Name',
  'pages.owner.orgNamePlaceholder': 'e.g., ACME Corporation',
  'pages.owner.orgCurrencies': 'Supported Currencies',
  'pages.owner.orgCurrenciesPlaceholder': 'Select currencies',
  'pages.owner.ownerSection': 'Owner Information',
  'pages.owner.ownerName': 'Name',
  'pages.owner.ownerNamePlaceholder': 'e.g., John Smith',
  'pages.owner.ownerUsername': 'Username (Member ID)',
  'pages.owner.ownerUsernamePlaceholder': 'e.g., john_smith',
  'pages.owner.ownerUsernameTooltip':
    'This will be used with SUBDOMAIN of organization too.',
  'pages.owner.ownerSubdomain': 'URL for authentication/workplace',
  'pages.owner.ownerSubdomainPlaceholder': 'e.g., dragon-node',
  'pages.owner.ownerSubdomainTooltip':
    'This will be used as authLocation.backoffice.com of organization too.',
  'pages.owner.ownerSubdomainFinalize': 'Finalize URL:',
  'pages.owner.ownerPhone': 'Phone Number (Optional)',
  'pages.owner.invalidPhone': 'Invalid phone number',
  'pages.owner.trialSection': 'Trial Settings',
  'pages.owner.trialDays': 'Trial Period (Days)',
  'pages.game.defaultConfig': 'Default Config', // English
  'pages.vendor.createdAt': 'Created At',
  'pages.vendor.gatewayId': 'Gateway ID',
  'pages.vendor.maintenance': 'Maintenance',

  'pages.player.transfer.title': 'Manage Balance',
  'pages.player.transfer.siteBalanceError':
    'Unable to verify site balance. Transaction aborted.',
  'pages.player.transfer.insufficientSiteBalance':
    'Insufficient Site Value! Site only has {balance}',
  'pages.player.transfer.insufficientPlayerBalance':
    'Insufficient Player Balance! Player only has {balance}',
  'pages.player.transfer.success': 'Transaction successful',
  'pages.player.transfer.failed': 'Transaction failed',
  'pages.player.transfer.walletContext': 'Wallet Context',
  'pages.player.transfer.player': 'Player',
  'pages.player.transfer.currentPlayerBalance': 'Current Player Balance',
  'pages.player.transfer.siteBalance': 'Site Value (House)',
  'pages.player.transfer.sitePlayersBalance': 'Site Players Balance (Total)',
  'pages.player.transfer.transactionType': 'Transaction Type',
  'pages.player.transfer.deposit': 'Deposit (Give to Player)',
  'pages.player.transfer.withdraw': 'Withdraw (Take from Player)',
  'pages.player.transfer.amount': 'Amount',
  'pages.player.transfer.amountRequired': 'Amount must be greater than 0',
  'pages.player.transfer.remark': 'Remark',
  'pages.player.transfer.remarkPlaceholder': 'Reason for adjustment',

  'pages.player.message-to-player': 'Send Message',
  'pages.player.batch-message-to-all-player': 'Send Message to All',

  'pages.player.drawer.title': 'Register New Player',
  'pages.player.drawer.sessionExpired':
    'Registration session expired. Please try again.',
  'pages.player.drawer.createSuccess':
    'Player verified and created successfully!',
  'pages.player.drawer.verifyFailed': 'Verification failed',
  'pages.player.drawer.required': 'This field is required',
  'pages.player.drawer.step.accountInfo': 'Account Info',
  'pages.player.drawer.otpSent':
    'Player created!, please confirm OTP or leave it unverifed players.',
  'pages.player.drawer.regFailed': 'Registration failed',
  'pages.player.drawer.siteSelection': 'Site Selection',
  'pages.player.drawer.selectSite': 'Select Site',
  'pages.player.drawer.playerDetails': 'Player Details',
  'pages.player.drawer.nickname': 'Nickname',
  'pages.player.drawer.nicknamePlaceholder': 'Display Name',
  'pages.player.drawer.phoneNumber': 'Phone Number',
  'pages.player.drawer.invalidPhone': 'Invalid phone number',
  'pages.player.drawer.countryCode': 'Country Code',
  'pages.player.drawer.step.verification': 'Verification',
  'pages.player.drawer.verifyTitle': 'Verify Mobile Number',
  'pages.player.drawer.verifySubtitle':
    'Please enter the 6-digit code sent to {phone}',
  'pages.player.drawer.otpLength': 'Must be 6 digits',
  'pages.player.drawer.otpRequired': 'Please enter OTP',
  'pages.player.drawer.otpLengthError': 'OTP must be 6 digits',

  // XCenter Page
  'pages.xcenter.title': 'X Center',
  'pages.xcenter.description':
    'Manage your AI services and resource allocations',
  'pages.xcenter.mode': '{mode} MODE',
  'pages.xcenter.sandbox': 'Sandbox',
  'pages.xcenter.syncHubs': 'Sync All Hubs',
  'pages.xcenter.saveConfig': 'Save Config',
  'pages.xcenter.balance': 'Budget Balance',
  'pages.controlCenter.bussinessRevenueBalance': 'Business Revenue Balance',
  'pages.xcenter.creditType': 'Credit Type',
  'pages.xcenter.activeHubs': 'Active Hubs',
  'pages.xcenter.online': 'Online',
  'pages.xcenter.ownerName': 'Owner Name',
  'pages.xcenter.id': 'ID',
  'pages.xcenter.lastUpdated': 'Last Updated',
  'pages.xcenter.ownerNotFound': 'Owner information not found',
  'pages.xcenter.configSaved': 'Configuration saved',
  'pages.xcenter.configSaveFailed': 'Failed to save configuration',
  'pages.xcenter.syncFailed': 'Failed to request hub synchronization',
  'pages.xcenter.noHubsFound': 'No hubs found to synchronize',
  'pages.xcenter.syncAccepted': 'Gateway synchronization request accepted',

  'component.siteSelector.refresh': 'refresh',
  'component.siteSelector.playerIdentifier': 'Select Player',
  'component.siteSelector.enterPlayer': 'enterPlayer',

  // Tools
  'pages.tools.magicEditor': 'Magic Editor',
  'pages.tools.cleanup': 'Cleanup',
  'pages.tools.magicEdit': 'Magic Edit',
  'pages.tools.placeDesign': 'Place Design',
  'pages.tools.colors': 'Colors',
  'pages.tools.newImage': 'New Image',
  'pages.tools.startCleanup': 'Start Cleanup',
  'pages.tools.detectRemoveLogos':
    'Automatically detect and remove logos, watermarks, and branding.',
  'pages.tools.describeMagic':
    'Describe what you want to change, add, or replace.',
  'pages.tools.magicPlaceholder': "E.g., Change 'New Member' to 'Welcome'...",
  'pages.tools.applyEdit': 'Apply Edit',
  'pages.tools.uploadDesign': 'Upload a design or prop to place on the image.',
  'pages.tools.clickToChange': 'Click to Change',
  'pages.tools.selectOverlay': 'Select Overlay Image',
  'pages.tools.instructionOptional': 'Instruction (Optional):',
  'pages.tools.placePlaceholder': 'E.g., Place it on the shirt center...',
  'pages.tools.mergeDesign': 'Merge Design',
  'pages.tools.currentPalette': 'Current Palette',
  'pages.tools.rescan': 'Re-scan',
  'pages.tools.scanColors': 'Scan Colors',
  'pages.tools.modifyTheme': 'Modify Theme',
  'pages.tools.themePlaceholder': 'E.g. Cyberpunk, Pastel...',
  'pages.tools.syncColors': 'Sync Colors',
  'pages.tools.selectToolToBegin': 'Select a tool to begin editing.',
  'pages.tools.editsMade': '{count} edits made',
  'pages.tools.originalImage': 'Original Image',
  'pages.tools.undo': 'Undo',
  'pages.tools.download': 'Download',
  'pages.tools.geminiWorking': 'Gemini is working...',
  'pages.tools.noImageLoaded': 'No image loaded',
  'pages.common.noData': 'No Data',
  'pages.common.key': 'Key',
  'pages.common.value': 'Value',
  'pages.vendor.images.dragger.title':
    'Click or drag file to this area to upload',
  'pages.vendor.images.dragger.hint': 'Support for a single or bulk upload.',
  // Management > Site List
  'pages.management.site-list.title': 'Site List',
  'pages.management.site-list.new': 'Add Site',
  'pages.management.site-list.sites': 'Sites',
  'pages.management.site-list.avgUniqueVisitors': 'Avg. Unique visitors',
  'pages.management.site-list.totalTraffic': 'Total traffic',
  'pages.management.site-list.searchNameLabel': 'Name',
  'pages.management.site-list.searchOwnerLabel': 'Owner',
  'pages.management.site-list.placeholder': 'Please enter Site Name or Org ID',
  'pages.management.site-list.listTitle': 'List of Sites',
  'pages.management.site-list.status.all': 'All',
  'pages.management.site-list.status.supportRequired': 'Requires support',
  'pages.management.site-list.status.supportResolved': 'Support resolved',
  'pages.management.site-list.orgId': 'Organization ID',
  'pages.management.site-list.revenueSummary': 'Revenue Summary',
  'pages.management.site-list.createdAt': 'Created At',
  'pages.management.site-list.edit': 'Edit',
  'pages.management.site-list.share': 'Share',
  'pages.management.site-list.delete': 'Delete',
  'pages.management.site-list.more': 'More',
  'pages.management.site-list.deleteConfirmTitle':
    'Are you sure you want to delete this site?',
  'pages.management.site-list.deleteConfirmContent':
    'This action cannot be undone.',
  'pages.management.site-list.form.siteName': 'Site Name',
  'pages.management.site-list.form.currencies': 'Currencies',
  'pages.management.site-list.form.orgId': 'Organization ID',
  'pages.management.site-list.form.config': 'Site Configuration (JSON)',
  'pages.management.site-list.form.siteNameRequired': 'Please enter site name',
  'pages.management.site-list.form.currenciesRequired':
    'Please select at least one currency',
  'pages.management.site-list.form.orgIdRequired':
    'Please enter organization ID',
  'pages.management.site-list.form.success': 'Operation Successful',
  'pages.management.site-list.form.backToList': 'Back to List',
  'pages.management.site-list.form.addAgain': 'Add Again',

  // Management > Site Manager
  'pages.management.site-manager.title': 'Site Management',
  'pages.management.site-manager.description': 'Manage your sites and scale lobbies with one click.',
  'pages.management.site-manager.balance': 'Balance',
  'pages.management.site-manager.provision': 'Provision',
  'pages.management.site-manager.newSite': 'New Site',
  'pages.management.site-manager.refresh': 'Refresh',
  'pages.management.site-manager.openMoreLobby': 'Open more lobby',
  'pages.management.site-manager.openWhiteLabel': 'Open more White Label House',
  'pages.management.site-manager.lobbiesCount': 'LOBBIES ({count})',
  'pages.management.site-manager.detail': 'DETAIL',
  'pages.management.site-manager.action': 'ACTION',
  'pages.management.site-manager.currentSite': 'Current Site',
  'pages.management.site-manager.switchToSite': 'Switch to this Site',
  'pages.management.site-manager.customizeTheme': 'Customize Theme',
  'pages.management.site-manager.playerAnalytic': 'Player Analytic',
  'pages.management.site-manager.configDb': 'Config DB',
  'pages.management.site-manager.comingSoon': 'Coming Soon',
  'pages.management.site-manager.scalingTitle': 'Open New Lobby',
  'pages.management.site-manager.scalingDesc': 'Create a new site (lobby) for scaling.',
  'pages.management.site-manager.parentSite': 'Parent Site',
  'pages.management.site-manager.newSiteName': 'New Site Name',
  'pages.management.site-manager.priceBreakdown': 'Price Breakdown',
  'pages.management.site-manager.creationFee': 'Site creation fee',
  'pages.management.site-manager.setupFee': 'Setup fee',
  'pages.management.site-manager.total': 'Total',
  'pages.management.site-manager.yourBalance': 'Your Balance',
  'pages.management.site-manager.afterPurchase': 'After Purchase',
  'pages.management.site-manager.insufficientBalance': 'Insufficient balance. Please top up your account.',
  'pages.management.site-manager.confirmDeduct': 'I confirm to deduct ${amount} from my account',
  'pages.management.site-manager.confirmCreate': 'Confirm & Create',
  'pages.management.site-manager.close': 'Close',
  'pages.management.site-manager.openNewHouse': 'Open New House',
  'pages.management.site-manager.selectSite': 'Select Site',
  'pages.management.site-manager.switchSuccess': 'Switched to site {name} successfully',


  // Management > Transactions
  'pages.management.transactions.txId': 'Transaction ID',
  'pages.management.transactions.playerId': 'Player ID',
  'pages.management.transactions.gameId': 'Game ID',
  'pages.management.transactions.at': 'Time',
  'pages.management.transactions.ref_code': 'Reference Code',

  // Vendor GGR Manager Page
  'pages.vendor.ggr.title': 'Vendor GGR Manager',
  'pages.vendor.ggr.subtitle': 'Revenue sharing & billing configuration',
  'pages.vendor.ggr.org': 'Org:',

  // Tabs
  'pages.vendor.ggr.tab.draft': 'Draft Vendors',
  'pages.vendor.ggr.tab.configure': 'Configure GGR',
  'pages.vendor.ggr.tab.simulate': 'Simulate Revenue',

  // Analytics translations
  'analytics.today': 'Today',
  'analytics.week': 'Week',
  'analytics.month': 'Month',
  'analytics.year': 'Year',
  'analytics.overview': 'Overview',
  'analytics.players': 'Player Activity',
  'analytics.finance': 'Financial',
  'analytics.products': 'Products',
  'analytics.bonus': 'Bonus & Costs',
  'analytics.markets': 'Markets',
  'analytics.ggr': 'GGR',
  'analytics.ngr': 'NGR',
  'analytics.activePlayers': 'Active Players',
  'analytics.houseEdge': 'House Edge',
  'analytics.revenueTrend': 'Revenue Trend (GGR vs NGR)',
  'analytics.productMix': 'Product Mix',
  'analytics.playerFunnel': 'Player Funnel',
  'analytics.activePlayersByProduct': 'Active Players by Product',
  'analytics.deposits': 'Deposits',
  'analytics.withdrawals': 'Withdrawals',
  'analytics.netDeposits': 'Net Deposits',
  'analytics.avgDeposit': 'Avg Deposit',
  'analytics.turnoverVsWinnings': 'Turnover vs Winnings',
  'analytics.depositBreakdown': 'Deposit Breakdown',
  'analytics.depositBreakdown.total': 'Total',
  'analytics.depositBreakdown.ftdCount': 'FTD Count',
  'analytics.depositBreakdown.depositCount': 'Deposit Count',
  'analytics.depositBreakdown.uniqueDepositors': 'Unique Depositors',
  'analytics.productPerformance': 'Product Performance Comparison',
  'analytics.totalBonus': 'Total Bonus',
  'analytics.bonusWithdrawn': 'Bonus Withdrawn',
  'analytics.cashback': 'Cashback',
  'analytics.bonusCostRatio': 'Bonus Cost Ratio',
  'analytics.bonusImpact': 'Bonus Impact on Revenue',
  'analytics.marketPerformance': 'Market Performance',
  'analytics.registrations': 'Registrations',
  'analytics.ftds': 'FTDs',
  'analytics.ftdConversion': 'FTD Conversion',
  'analytics.depositPenetration': 'Deposit Penetration',
  'analytics.turnover': 'Turnover',

  // Draft Vendors Tab
  'pages.vendor.ggr.draft.title': 'Select Vendors',
  'pages.vendor.ggr.draft.subtitle':
    'Choose vendors to add to your organization',
  'pages.vendor.ggr.draft.search': 'Search vendors...',
  'pages.vendor.ggr.draft.all': 'All',
  'pages.vendor.ggr.draft.available': '{count} vendors available',
  'pages.vendor.ggr.draft.selected': '{count} selected',
  'pages.vendor.ggr.draft.noMatch': 'No vendors match your criteria',

  // Vendor Card
  'pages.vendor.ggr.card.ggrRate': 'GGR Rate:',
  'pages.vendor.ggr.card.platform': 'Platform:',
  'pages.vendor.ggr.card.billing': 'Billing: Day',
  'pages.vendor.ggr.card.fees': 'Fees:',

  // Configure GGR Tab
  'pages.vendor.ggr.config.title': 'GGR Tier Configuration',
  'pages.vendor.ggr.config.subtitle':
    'Configure revenue sharing rates and billing schedules',
  'pages.vendor.ggr.config.selectTier': 'Select Tier to Edit',
  'pages.vendor.ggr.config.selectTierEmpty': 'Select a Tier',
  'pages.vendor.ggr.config.selectTierEmptyDesc':
    'Choose a tier from the left to configure its settings',

  // GGR Tier Config Form
  'pages.vendor.ggr.config.minGGR': 'Min GGR (USDT)',
  'pages.vendor.ggr.config.maxGGR': 'Max GGR (USDT)',
  'pages.vendor.ggr.config.unlimited': 'Unlimited',
  'pages.vendor.ggr.config.vendorRate': 'Vendor Rate',
  'pages.vendor.ggr.config.platformRate': 'Platform Rate',
  'pages.vendor.ggr.config.maintenanceFee': 'Maintenance Fee',
  'pages.vendor.ggr.config.serviceFee': 'Service Fee',
  'pages.vendor.ggr.config.billingSchedule': 'Billing Schedule',
  'pages.vendor.ggr.config.billDay': 'Bill Day',
  'pages.vendor.ggr.config.fineDays': 'Fine Days',
  'pages.vendor.ggr.config.suspend': 'Suspend',
  'pages.vendor.ggr.config.terminate': 'Terminate',

  // Organization Hierarchy
  'pages.org.hierarchy.member': 'Member',
  'pages.org.hierarchy.operator': 'Operator',
  'pages.org.hierarchy.operators': 'Operators',

  // Site Hierarchy
  'pages.site.hierarchy.environment': 'Environment',
  'pages.site.hierarchy.player': 'Player',
  'pages.site.hierarchy.players': 'Players',

  // Simulate Revenue Tab
  'pages.vendor.ggr.simulate.title': 'Revenue Simulation',
  'pages.vendor.ggr.simulate.subtitle':
    'Estimate payments and view billing schedules',
  'pages.vendor.ggr.simulate.noVendors': 'No Vendors Selected',
  'pages.vendor.ggr.simulate.noVendorsDesc':
    'Select vendors from the list to simulate revenue sharing',

  // Revenue Simulator Cards
  'pages.vendor.ggr.simulate.totalGGR': 'Total GGR',
  'pages.vendor.ggr.simulate.totalGGRTooltip':
    'Total Gross Gaming Revenue from selected vendors',
  'pages.vendor.ggr.simulate.vendorShare': 'Vendor Share',
  'pages.vendor.ggr.simulate.vendorShareTooltip':
    'Estimated share to be paid to vendors',
  'pages.vendor.ggr.simulate.platformShare': 'Platform Share',
  'pages.vendor.ggr.simulate.platformShareTooltip':
    'Estimated share retained by the platform',
  'pages.vendor.ggr.simulate.totalDue': 'Total Due',
  'pages.vendor.ggr.simulate.totalDueTooltip':
    'Total amount due including maintenance and service fees',

  // Revenue Distribution
  'pages.vendor.ggr.simulate.distribution': 'Revenue Distribution',
  'pages.vendor.ggr.simulate.perVendor': 'Per-Vendor Simulation',
  'pages.vendor.ggr.simulate.estimatedGGR': 'Estimated GGR',
  'pages.vendor.ggr.simulate.vendor': 'Vendor:',
  'pages.vendor.ggr.simulate.platform': 'Platform:',
  'pages.vendor.ggr.simulate.fees': 'Fees:',
  'pages.vendor.ggr.simulate.total': 'Total:',

  // Payment Schedule Table
  'pages.vendor.ggr.simulate.schedule': 'Payment Schedule & Deadlines',
  'pages.vendor.ggr.simulate.table.vendor': 'Vendor',
  'pages.vendor.ggr.simulate.table.amount': 'Amount',
  'pages.vendor.ggr.simulate.table.due': 'Due',
  'pages.vendor.ggr.simulate.table.fine': 'Fine',
  'pages.vendor.ggr.simulate.table.suspend': 'Suspend',
  'pages.vendor.ggr.simulate.table.terminate': 'Terminate',
  'pages.vendor.ggr.simulate.table.total': 'Total',

  // Vendor GGR - Missing translations
  'pages.vendor.ggr.selectVendor': 'Select Vendor',
  'pages.vendor.ggr.tab.tiers': 'GGR Tiers',
  'pages.vendor.ggr.tab.contract': 'Contract',
  'pages.vendor.ggr.config.addFirstTier': 'Add First Tier',
  'pages.vendor.ggr.config.addTier': 'Add Tier',

  // Vendor Image Upload
  'pages.vendor.image.title': 'Vendor Images',
  'pages.vendor.image.subtitle': 'Manage vendor images and categories',
  'pages.vendor.image.upload': 'Upload Image',
  'pages.vendor.image.uploadSuccess': 'Image uploaded successfully',
  'pages.vendor.image.uploadError': 'Failed to upload image',
  'pages.vendor.image.deleteSuccess': 'Image deleted successfully',
  'pages.vendor.image.deleteError': 'Failed to delete image',
  'pages.vendor.image.vendorName': 'Vendor Name',
  'pages.vendor.image.categories': 'Categories',
  'pages.vendor.image.currentImages': 'Current Images',
  'pages.vendor.image.invalidFile': 'Invalid file type',
  'pages.vendor.image.fileTooLarge': 'File too large (max 2MB)',

  'pages.support.robot.welcome':
    'Hello! I am your AI assistant. How can I help you today?',
  'pages.support.robot.placeholder': 'Ask me anything...',

  // Exception Pages
  'pages.403.subTitle': 'Sorry, you are not authorized to access this page.',
  'pages.403.buttonText': 'Back to home',

  // Component: Footer
  'component.footer.copyright':
    '2026 EIGHT DRAGON GLOBAL. All rights reserved. ·',
  'component.footer.contact': 'Contact us',

  // Component: AvatarDropdown
  'component.avatarDropdown.account': 'Account',
  'component.avatarDropdown.logout': 'Logout',

  // Component: SiteSelector
  'component.siteSelector.title': 'Select Site & Player',
  'component.siteSelector.description':
    'Select site to continue your operation.',
  'component.siteSelector.selectLobby':
    'Please select the lobby site to test the game',
  'component.siteSelector.placeholder': 'Select Lobby Site',
  'component.siteSelector.confirm': 'Launch Game',
  'component.siteSelector.cancel': 'Cancel',
  'component.siteSelector.currentSiteLobby': 'Site Lobby',
  'component.siteSelector.playerPlaceholder': 'Select a player...',
  'component.siteSelector.loadingSites': 'Loading Players...',

  // Component: GameLaunchOverlay
  'component.gameLaunch.scanOrPress':
    'Scan QR Code or press button to play game',
  'component.gameLaunch.openNewWindow': 'Open game in new window',
  'component.gameLaunch.copyUrl': 'Copy URL',
  'component.gameLaunch.copySuccess': 'URL copied successfully',
  'component.gameLaunch.copyFailed': 'Cannot copy URL',
  'component.gameLaunch.sessionID': 'Session ID:',
  'component.gameLaunch.goToMonitor': 'Go to Player Monitor',

  // Component: FullPageLoading
  'component.loading.tip': '...',

  // Component: MagicEditor
  'component.magicEditor.editsMade': '{count} edits made',
  'component.magicEditor.originalImage': 'Original Image',
  'component.magicEditor.undo': 'Undo',
  'component.magicEditor.download': 'Download',
  'component.magicEditor.geminiWorking': 'Gemini is working...',
  'component.magicEditor.noImageLoaded': 'No image loaded',
  'component.magicEditor.detectRemoveLogos':
    'Automatically detect and remove logos, watermarks, and branding.',
  'component.magicEditor.startCleanup': 'Start Cleanup',
  'component.magicEditor.describeMagic':
    'Describe what you want to change, add, or replace.',
  'component.magicEditor.magicPlaceholder':
    "E.g., Change 'New Member' to 'Welcome'...",
  'component.magicEditor.applyEdit': 'Apply Edit',
  'component.magicEditor.uploadDesign':
    'Upload a design or prop to place on the image.',
  'component.magicEditor.clickToChange': 'Click to Change',
  'component.magicEditor.selectOverlay': 'Select Overlay Image',
  'component.magicEditor.instructionOptional': 'Instruction (Optional):',
  'component.magicEditor.placePlaceholder':
    'E.g., Place it on the shirt center...',
  'component.magicEditor.mergeDesign': 'Merge Design',
  'component.magicEditor.currentPalette': 'Current Palette',
  'component.magicEditor.rescan': 'Re-scan',
  'component.magicEditor.scanColors': 'Scan Colors',
  'component.magicEditor.modifyTheme': 'Modify Theme',
  'component.magicEditor.themePlaceholder': 'E.g. Cyberpunk, Pastel...',
  'component.magicEditor.syncColors': 'Sync Colors',
  'component.magicEditor.selectToolToBegin': 'Select a tool to begin editing.',
  'component.magicEditor.agenticAI': 'Agentic AI',
  'component.magicEditor.uploadNewImage': 'Upload New Image',
  'component.magicEditor.newImage': 'New Image',
  'component.magicEditor.cleanup': 'Cleanup',
  'component.magicEditor.magicEdit': 'Magic Edit',
  'component.magicEditor.placeDesign': 'Place Design',
  'component.magicEditor.colors': 'Colors',
  'component.magicEditor.imageUploaded': 'Image uploaded successfully',
  'component.magicEditor.logosRemoved': 'Logos removed',
  'component.magicEditor.logoRemoveFailed':
    'Failed to remove logo. Please try again.',
  'component.magicEditor.editApplied': 'Edit applied',
  'component.magicEditor.editFailed':
    'Failed to process edit. Please try again.',
  'component.magicEditor.colorsSynced': 'Colors synced',
  'component.magicEditor.recolorFailed':
    'Failed to recolor image. Please try again.',
  'component.magicEditor.designPlaced': 'Design placed successfully',
  'component.magicEditor.placeFailed':
    'Failed to place design. Please try again.',
  'component.magicEditor.extractingPalette': 'Extracting palette...',
  'component.magicEditor.paletteExtracted': 'Palette extracted',
  'component.magicEditor.paletteFailed':
    'Failed to extract palette. Please try again.',
  // Management: Player List
  'pages.management.players.title': 'Player Management',
  'pages.management.players.player': 'Player',
  'pages.management.players.anonymous': 'Anonymous',
  'pages.management.players.id': 'ID',
  'pages.management.players.siteId': 'Site ID',
  'pages.management.players.currency': 'Currency',
  'pages.management.players.balance': 'Balance',
  'pages.management.players.status': 'Status',
  'pages.management.players.status.active': 'Active',
  'pages.management.players.status.inactive': 'Inactive',
  'pages.management.players.status.banned': 'Banned',
  'pages.management.players.createdAt': 'Created At',
  'pages.management.players.total': 'Total {total} players',
  'pages.management.players.transactionHistory': 'Transaction History',
  'management.playerDetail.title': 'Player Details',

  // Withdraw History
  'withdraw.history.createdAt': 'Created At',
  'withdraw.history.bonusName': 'Bonus Name',
  'withdraw.history.slip': 'Slip',

  // Management: Transaction List
  'pages.login.pleaseVerifyCaptcha': 'Please verify that you are not a robot.',
  'pages.management.transactions.profit': 'Profit',
  'pages.management.transactions.siteId': 'Site ID',
  'pages.management.transactions.amount': 'Amount',
  'pages.management.transactions.type': 'Type',
  'pages.management.transactions.type.deposit': 'Deposit',
  'pages.management.transactions.type.withdraw': 'Withdraw',
  'pages.management.transactions.type.transfer': 'Transfer',
  'pages.management.transactions.type.bet': 'Bet',
  'pages.management.transactions.type.win': 'Win',
  'pages.management.transactions.status': 'Status',
  'pages.management.transactions.status.success': 'Success',
  'pages.management.transactions.status.pending': 'Pending',
  'pages.management.transactions.status.failed': 'Failed',
  'pages.management.transactions.createdAt': 'Created At',

  // Management: Site Builder
  'pages.management.site-builder.comingSoon': 'Coming Soon!',
  'pages.management.site-builder.onDevelopment':
    'On development site builder for ya!',

  // XUDO: XHub
  'pages.xudo.xhub.search': 'Search',
  'pages.xudo.xhub.reset': 'Reset',
  'pages.xudo.xhub.searchPlaceholder': 'Search {dataIndex}',
  'pages.xudo.xhub.healthy': 'HEALTHY',
  'pages.xudo.xhub.selectItems': 'Please select items to delete',

  // XUDO: XGame
  'pages.xudo.game.id': 'ID',
  'pages.xudo.game.gameCode': 'Game Code',
  'pages.xudo.game.vendorId': 'Vendor ID',
  'pages.xudo.game.category': 'Category',
  'pages.xudo.game.icons': 'Icons',
  'pages.xudo.game.maintenanceAt': 'Maintenance At',
  'pages.xudo.game.maintenanceAnnouncement': 'Maintenance Announcement',
  'pages.xudo.game.createdAt': 'Created At',
  'pages.xudo.game.updatedAt': 'Updated At',
  'pages.xudo.game.defaultConfig': 'Default Config',
  'pages.xudo.game.launchFailed': 'Failed to launch game',
  'pages.xudo.game.launching': 'Launching...',
  'pages.xudo.game.selectSiteTitle': 'Select Site to Test Game',
  'pages.xudo.game.tab.all': 'All',
  'pages.xudo.game.msg.launched': 'Game launched successfully!',
  'pages.xudo.game.msg.launchFailed': 'Failed to launch game',
  'pages.xudo.game.msg.deleted': 'Deleted',
  'pages.xudo.game.msg.updated': 'Updated successfully',
  'pages.xudo.game.msg.maintenance': 'Game is under maintenance',
  'pages.xudo.game.btn.deactivate': 'Deactivate',
  'pages.xudo.game.btn.update': 'Update',
  'pages.xudo.game.btn.delete': 'Delete',
  'pages.xudo.game.selectedCount': '{count} selected',
  'pages.player.drawer.otpTitle': 'รหัสยืนยัน 6 หลัก',

  // XUDO: XHub Forms
  'pages.xudo.xhub.form.select': 'Select',
  'pages.xudo.xhub.form.selectCountry': 'Please select a country',
  'pages.xudo.xhub.form.maintenanceTooltip':
    'Set a date to schedule maintenance. Clear to set as Healthy.',
  'pages.xudo.xhub.form.envTooltip':
    'Custom key-value pairs for hub environment (e.g., XGLOBAL_SITE, XGLOBAL_PUBLIC_KEY)',
  'pages.xudo.xhub.form.standardServerApis': 'Standard Server APIs',
  'pages.xudo.xhub.form.apiEndpointTooltip':
    'Primary API endpoints for the hub',
  'pages.xudo.xhub.form.apiPlaceholder': 'https://jsgame.live',
  'pages.xudo.xhub.form.igmHubSeamless': 'IGM Gateway Seamless',
  'pages.xudo.xhub.form.seamlessApis': 'Seamless APIs',
  'pages.xudo.xhub.form.seamlessPlaceholder': 'https://huidu.x8dg.uk',
  'pages.xudo.xhub.form.healthCheckPath': 'Health Check Path',
  'pages.xudo.xhub.form.healthCheckPlaceholder': '/health',
  'pages.xudo.xhub.form.whitelistCidrs': 'Whitelist Callback CIDRs',
  'pages.xudo.xhub.form.cidrsTooltip': 'IP ranges allowed for callbacks',
  'pages.xudo.xhub.form.rawConnectionConfig':
    'Raw Connection Config (Other Fields)',
  'pages.xudo.xhub.form.rawConfigTooltip':
    'Edit additional keys in connection_config that are not listed above.',

  // Org: Analysis
  'pages.org.analysis.excelView': 'Excel View (coming soon)',
  'pages.org.analysis.csvView': 'CSV View (coming soon)',

  // Org: Monitor
  'pages.org.monitor.liveGrossRevenue': 'Live Gross Revenue Growth',
  'pages.org.monitor.watch': 'Watch',

  // Account: Settings - Base
  'pages.account.settings.base.areaCodeRequired':
    'Please input your area code!',
  'pages.account.settings.base.phoneRequired':
    'Please input your phone number!',
  'pages.account.settings.base.updateSuccess':
    'Basic information updated successfully',
  'pages.account.settings.base.submitText': 'Update Information',
  'pages.account.settings.base.displayName': 'Display Name',
  'pages.account.settings.base.displayNameRequired': 'Please input your name!',
  'pages.account.settings.base.username': 'Username',
  'pages.account.settings.base.usernameRequired': 'Please input your username!',
  'pages.account.settings.base.phoneNumber': 'Phone Number',
  'pages.account.settings.base.accountInfo': 'Account Information',
  'pages.account.settings.base.userUid': 'User UID',
  'pages.account.settings.base.orgId': 'Organization ID',
  'pages.account.settings.base.systemRole': 'System Role',
  'pages.account.settings.base.orgRole': 'Organization Role',
  'pages.account.settings.base.accountStatus': 'Account Status',
  'pages.account.settings.base.creditType': 'Credit Type',
  'pages.account.settings.base.usdtBalance': 'USDT Credit Balance',
  'pages.account.settings.base.integrationSettings': 'Integration Settings',
  'pages.account.settings.base.superiaProjectUrl': 'Superia Project URL',
  'pages.account.settings.base.superiaPublishableKey':
    'Superia Publishable Key',
  'pages.account.settings.base.avatar': 'Avatar',
  'pages.account.settings.base.changeAvatar': 'Change Avatar',

  // Account: Settings - Security
  'pages.account.settings.security.strong': 'Strong',
  'pages.account.settings.security.medium': 'Medium',
  'pages.account.settings.security.weak': 'Weak',
  'pages.account.settings.security.accountPassword': 'Account Password',
  'pages.account.settings.security.currentStrength':
    'Current password strength:',
  'pages.account.settings.security.modify': 'Modify',
  'pages.account.settings.security.backupPhone': 'Backup Phone',
  'pages.account.settings.security.boundPhone': 'Bound phone:',
  'pages.account.settings.security.backupQuestion': 'Backup Question',
  'pages.account.settings.security.noBackupQuestion':
    'No backup question set, backup questions can effectively protect account security',
  'pages.account.settings.security.set': 'Set',
  'pages.account.settings.security.backupEmail': 'Backup Email',
  'pages.account.settings.security.boundEmail': 'Bound email:',
  'pages.account.settings.security.mfaDevice': 'MFA Device',
  'pages.account.settings.security.noMfaDevice':
    'No MFA device bound, binding after can perform secondary confirmation',
  'pages.account.settings.security.bind': 'Bind',

  // Account: Settings - Binding
  'pages.account.settings.binding.taobao': 'Bind Taobao',
  'pages.account.settings.binding.taobaoNotBound':
    'Currently not bound to Taobao account',
  'pages.account.settings.binding.alxpay': 'Bind Alxpay',
  'pages.account.settings.binding.alxpayNotBound':
    'Currently not bound to Alxpay account',
  'pages.account.settings.binding.dingtalk': 'Bind DingTalk',
  'pages.account.settings.binding.dingtalkNotBound':
    'Currently not bound to DingTalk account',
  'pages.account.settings.binding.bind': 'Bind',

  // Account: Center
  'pages.account.center.assetBalance': 'Asset Balance',
  'pages.account.center.creditLimit': 'Credit Limit',
  'pages.account.center.wallet': 'Wallet',
  'pages.account.center.increase': 'Increase',
  'pages.account.center.card': 'Card',
  'pages.account.center.confirmed': 'Confirmed',
  'pages.account.center.success': 'SUCCESS',
  'pages.account.center.binance': 'BINANCE',
  'pages.account.center.instant': 'Instant',
  'pages.account.center.publishedAt': 'Published at',

  // Welcome Page
  'pages.welcome.title': 'Welcome to iGM Backoffice',
  'pages.welcome.description':
    'iGM Backoffice is a comprehensive platform integrating umi, Ant Design and ProComponents. It is designed to provide a seamless experience for managing gaming operations, player management, and site configuration.',
  'pages.welcome.learnMore': 'Learn more',
  'pages.welcome.card1.title': 'Learn umi',
  'pages.welcome.card1.desc':
    'umi is an extensible enterprise-level front-end application framework. It is routing-based and supports both configuration-based and convention-based routing.',
  'pages.welcome.card2.title': 'Learn Ant Design',
  'pages.welcome.card2.desc':
    'antd is a React UI component library based on Ant Design, mainly used for developing enterprise-level backend products.',
  'pages.welcome.card3.title': 'Learn Pro Components',
  'pages.welcome.card3.desc':
    'ProComponents is a template component library based on Ant Design with higher abstraction, designed with the philosophy of one component per page.',

  // Result: Fail
  'pages.result.fail.title': 'Submission Failed',
  'pages.result.fail.subTitle':
    'Please verify and modify the following information, then resubmit.',
  'pages.result.fail.errorTitle': 'Your submission has the following errors:',
  'pages.result.fail.accountFrozen': 'Your account has been frozen',
  'pages.result.fail.unfreezeNow': 'Unfreeze now',
  'pages.result.fail.notEligible': 'Your account is not yet eligible to apply',
  'pages.result.fail.upgradeNow': 'Upgrade now',
  'pages.result.fail.returnToModify': 'Return to modify',

  // Result: Success
  'pages.result.success.title': 'Submission Success',
  'pages.result.success.subTitle':
    'The submission result page is used to feedback the processing results of a series of operational tasks. If it is only a simple operation, use the Message global prompt feedback. This text area can display simple supplementary explanations.',
  'pages.result.success.backToList': 'Back to list',
  'pages.result.success.viewProject': 'View project',
  'pages.result.success.print': 'Print',
  'pages.result.success.projectName': 'Project Name',
  'pages.result.success.projectId': 'Project ID',
  'pages.result.success.principal': 'Principal',
  'pages.result.success.effectiveTime': 'Effective Time',
  'pages.result.success.createProject': 'Create Project',
  'pages.result.success.departmentReview': 'Departmental Review',
  'pages.result.success.financialReview': 'Financial Review',
  'pages.result.success.finish': 'Finish',
  'pages.result.success.urge': 'Urge',

  // Quota & Billing
  'pages.fund.title': 'Quota & Billing',
  'pages.fund.tab.asset': 'Assets',
  'pages.fund.subtitle': 'Manage your site fund and billing',
  'pages.fund.packages.title': 'Available Packages',
  'pages.fund.packages.sites': 'Site Packages',
  'pages.fund.packages.storage': 'Storage Packages',
  'pages.fund.packages.bandwidth': 'Bandwidth Packages',
  'pages.fund.currentUsage': 'Current Usage',
  'pages.fund.totalSites': 'Total Sites',
  'pages.fund.sitesUsed': 'Sites Used',
  'pages.fund.sitesRemaining': 'Sites Remaining',
  'pages.fund.buyQuota': 'Buy Quota',
  'pages.fund.purchase': 'Purchase',
  'pages.fund.paymentMethod': 'Payment Method',
  'pages.fund.crypto': 'Cryptocurrency',
  'pages.fund.price': 'Price',
  'pages.fund.quantity': 'Quantity',
  'pages.fund.total': 'Total',
  'pages.fund.status': 'Status',
  'pages.fund.active': 'Active',
  'pages.fund.pending': 'Pending',
  'pages.fund.completed': 'Completed',
  'pages.fund.discount': 'Discount',
  'pages.fund.popular': 'Popular',
  'pages.fund.perSite': 'per site',
  'pages.fund.savings': 'You save',

  // Billing
  'pages.billing.title': 'Billing',
  'pages.billing.balance': 'Balance',
  'pages.billing.availableBalance': 'Available Balance',
  'pages.billing.topup': 'Top Up',
  'pages.billing.topupCrypto': 'Top Up with Crypto',
  'pages.billing.topupAmount': 'Top Up Amount',
  'pages.billing.selectCurrency': 'Select Currency',
  'pages.billing.paymentAddress': 'Payment Address',
  'pages.billing.copyAddress': 'Copy Address',
  'pages.billing.copied': 'Copied!',
  'pages.billing.waitingPayment': 'Waiting for payment...',
  'pages.billing.paymentConfirmed': 'Payment confirmed!',
  'pages.billing.paymentExpired': 'Payment expired',
  'pages.billing.transactionHistory': 'Transaction History',
  'pages.billing.noTransactions': 'No transactions found',
  'pages.billing.date': 'Date',
  'pages.billing.type': 'Type',
  'pages.billing.deposit': 'Deposit',
  'pages.billing.purchase': 'Purchase',
  'pages.billing.refund': 'Refund',

  // Payment Modal
  'pages.payment.step.creating': 'Creating',
  'pages.payment.step.payment': 'Payment',
  'pages.payment.step.complete': 'Complete',
  'pages.payment.creatingRequest': 'Creating your payment request...',
  'pages.payment.creatingUsdtRequest': 'Creating your USDT payment request...',
  'pages.payment.details': 'Payment Details',
  'pages.payment.usdtDetails': 'USDT Payment Details',
  'pages.payment.waiting': 'Waiting for payment...',
  'pages.payment.amount': 'Amount',
  'pages.payment.amountToPay': 'Amount to Pay',
  'pages.payment.usdValue': 'USD Value',
  'pages.payment.fund': 'Quota',
  'pages.payment.siteName': 'Site Name',
  'pages.payment.network': 'Network',
  'pages.payment.scanToPay': 'Scan to Pay',
  'pages.payment.sendExactly': 'Send exactly {amount} {currency}',
  'pages.payment.copy': 'Copy',
  'pages.payment.address': 'Address',
  'pages.payment.received': 'Received: {amount} {currency}',
  'pages.payment.expiresAt': 'This payment request expires at {date}',
  'pages.payment.important': 'Important:',
  'pages.payment.warningNetwork': 'Send only USDT on this network!',
  'pages.payment.warningSendOnly': '• Send only USDT on the {network} network',
  'pages.payment.warningLoss':
    '• Sending other tokens or using wrong network may result in permanent loss',
  'pages.payment.warningExact': '• Send the exact amount shown above',
  'pages.payment.success.title': 'Payment Completed!',
  'pages.payment.success.quotaAdded':
    'Your fund has been added and site "{siteName}" is being provisioned.',
  'pages.payment.success.topupAdded':
    'Your topup of ${amount} has been added to your balance.',
  'pages.payment.success.viewSites': 'View My Sites',
  'pages.payment.success.close': 'Close',
  'pages.payment.failed.title': 'Payment Failed',
  'pages.payment.failed.subtitle':
    'The payment could not be processed. Please try again.',
  'pages.payment.failed.close': 'Close',
  'pages.payment.error.create': 'Failed to create payment',
  'pages.payment.cancelled': 'Payment cancelled',

  // Settings Pages
  'pages.settings.save': 'Save Changes',
  'pages.settings.reset': 'Reset',

  // API Config
  'pages.settings.apiConfig.saveSuccess':
    'API configuration saved successfully',
  'pages.settings.apiConfig.saveError': 'Failed to save API configuration',
  'pages.settings.apiConfig.general': 'General Settings',
  'pages.settings.apiConfig.authentication': 'Authentication',
  'pages.settings.apiConfig.baseURL': 'Base URL',
  'pages.settings.apiConfig.timeout': 'Timeout (ms)',
  'pages.settings.apiConfig.retryAttempts': 'Retry Attempts',
  'pages.settings.apiConfig.enableLogging': 'Enable Logging',
  'pages.settings.apiConfig.authType': 'Authentication Type',
  'pages.settings.apiConfig.apiKey': 'API Key',
  'pages.settings.apiConfig.customHeaders': 'Custom Headers (JSON)',

  // Social Links
  'pages.settings.socialLinks.saveSuccess': 'Social links saved successfully',
  'pages.settings.socialLinks.saveError': 'Failed to save social links',
  'pages.settings.socialLinks.title': 'Social Media Links',
  'pages.settings.socialLinks.description':
    'Connect your social media accounts to display on your profile',
  'pages.settings.socialLinks.website': 'Website',
  'pages.settings.socialLinks.facebook': 'Facebook',
  'pages.settings.socialLinks.twitter': 'Twitter / X',
  'pages.settings.socialLinks.instagram': 'Instagram',
  'pages.settings.socialLinks.youtube': 'YouTube',
  'pages.settings.socialLinks.linkedin': 'LinkedIn',
  'pages.settings.socialLinks.github': 'GitHub',
  'pages.settings.socialLinks.discord': 'Discord',
  'pages.settings.socialLinks.telegram': 'Telegram',

  // Typography
  'pages.settings.typography.saveSuccess':
    'Typography settings saved successfully',
  'pages.settings.typography.saveError': 'Failed to save typography settings',
  'pages.settings.typography.fontSettings': 'Font Settings',
  'pages.settings.typography.fontFamily': 'Font Family',
  'pages.settings.typography.baseFontSize': 'Base Font Size (px)',
  'pages.settings.typography.lineHeight': 'Line Height',
  'pages.settings.typography.letterSpacing': 'Letter Spacing (px)',
  'pages.settings.typography.fontWeightNormal': 'Normal Font Weight',
  'pages.settings.typography.fontWeightBold': 'Bold Font Weight',
  'pages.settings.typography.colors': 'Colors',
  'pages.settings.typography.primaryColor': 'Primary Color',
  'pages.settings.typography.secondaryColor': 'Secondary Color',
  'pages.settings.typography.textColor': 'Text Color',
  'pages.settings.typography.preview': 'Live Preview',

  // Player Detail
  'player.detail.title': 'Player Details',
  'player.detail.profile': 'Profile',
  'player.detail.nickname': 'Nickname',
  'player.detail.registeredAt': 'Registered At',
  'player.detail.phone': 'Phone',
  'player.detail.affiliateFrom': 'Affiliate From',
  'player.detail.playerCountryCode': 'Preferred Language',
  'player.detail.preferredCurrency': 'Preferred Currency',
  'player.detail.uat': 'UAT',
  'player.detail.creditBalance': 'Credit Balance',
  'player.detail.export': 'Export',
  'player.detail.player.username': 'Username',

  // Player History
  'player.detail.history.createdAt': 'Created At',
  'player.detail.history.bonusName': 'Bonus Name',
  'player.detail.history.source': 'Source',
  'player.detail.history.amount': 'Amount',
  'player.detail.history.before': 'Before',
  'player.detail.history.after': 'After',
  'player.detail.history.bonus': 'Bonus',
  'player.detail.history.received': 'Received',
  'player.detail.history.turnover': 'Turnover',
  'player.detail.history.status': 'Status',
  'player.detail.history.updatedBy': 'Updated By',

  // Withdraw Info
  'player.detail.withdrawInfo': 'Withdraw Information',
  'player.detail.withdraw.date': 'Date',
  'player.detail.withdraw.amount': 'Amount',
  'player.detail.withdraw.bankName': 'Bank Name',
  'player.detail.withdraw.accountNo': 'Account No',
  'player.detail.withdraw.accountName': 'Account Name',
  'player.detail.withdraw.source': 'Source',
  'player.detail.withdraw.note': 'Note',

  // Missing translations from error logs
  'fund.tab.asset.title': 'Assets',
  'fund.balance.pending.label': 'Pending',

  // Fund topup form
  'fund.topup.form.selectCrypto': 'Select cryptocurrency to topup',
  'fund.topup.form.amountLabel': 'Enter amount to invest',
  'fund.topup.form.minAmountHint': 'Minimum {amount} {currency}',
  'fund.topup.form.submit': 'Transfer {amount}',
  'fund.topup.form.exchangeNotice': 'Your {crypto} will be automatically converted to USDT at current market rate',
  'fund.topup.form.finalCurrency': 'All funds will be credited as USDT',
  'pages.fund.purchase.disabled': 'Package Purchase Disabled',
  'pages.fund.purchase.disabledMessage': 'Package purchase feature has been removed. Please contact support for fund requests.',
  'pages.fund.purchase.close': 'Close',

  'fund.transactions.title': 'Transactions',
  'fund.status.completed': 'Completed',
  'fund.status.pending': 'Pending',

  // Realtime Monitoring Page
  'pages.org.rtm.title': 'Realtime Monitoring',
  'pages.org.rtm.loading': 'Loading player sessions...',
  'pages.org.rtm.error.title': 'Failed to connect to API',
  'pages.org.rtm.error.description': 'Please check:',
  'pages.org.rtm.error.network': 'Your network connection is active',
  'pages.org.rtm.error.server': 'API server is running at',
  'pages.org.rtm.error.cors': 'CORS is properly configured',
  'pages.org.rtm.error.firewall': 'Firewall is not blocking the request',
  'pages.org.rtm.retry': 'Retry Connection',
  'pages.org.rtm.attempt': 'Attempt',
  'pages.org.rtm.selectPlayer': 'Select a player to monitor',

  // Redis Error Messages
  'pages.redis.missingConfig': 'Redis configuration is missing for this site',
  'pages.redis.clientNotInitialized': 'Redis connection not established. Please try switching sites again.',
  'pages.org.rtm.sessionId': 'Session ID',
  'pages.org.rtm.playerId': 'Player ID',
  'pages.org.rtm.gateway': 'Gateway',
  'pages.org.rtm.transactions': 'Transactions',
  'pages.org.rtm.liveData': 'Live Data Stream',
  'pages.org.rtm.totalSessions': 'Total Sessions',
  'pages.org.rtm.playing': 'Playing',
  'pages.org.rtm.idle': 'Idle',
  'pages.org.rtm.creating': 'Creating',
  'pages.org.rtm.refresh': 'Refresh',
  'pages.org.rtm.player': 'Player',
  'pages.org.rtm.balance': 'Balance',
  'fund.status.processing': 'Processing',
  'fund.status.failed': 'Failed',
  'fund.status.rejected': 'Rejected',
  'fund.transactions.action.viewDetails': 'View Details',
  'fund.transactions.action.downloadReceipt': 'Download Receipt',
  'fund.topup.modal.paymentRejected': 'Payment Rejected',
  'fund.topup.modal.paymentRejectedMessage': 'Your payment was rejected. Please try again.',
  'fund.topup.modal.close': 'Close',
  'fund.topup.modal.creating': 'Creating',
  'fund.topup.modal.payment': 'Payment',
  'fund.topup.modal.done': 'Done',
  'fund.topup.modal.preparingAddress': 'Preparing your {cryptoLabel} payment address...',
  'fund.topup.modal.autoConverted': 'Auto-converted to USDT',
  'fund.topup.modal.copyAddress': 'Copy address',
  'fund.topup.modal.copyExactAmount': 'Copy exact amount — {amount} {crypto}',
  'fund.topup.modal.expiresAt': 'Expires at',
  'fund.topup.modal.sendOnly': 'Send only {cryptoLabel} on {networkLabel}',
  'fund.topup.modal.paymentReceived': 'Payment Received!',
  'fund.topup.modal.paymentReceivedMessage': '{amount} USD has been added to your USDT balance',
  'fund.crypto.searchPlaceholder': 'Search currency (e.g. USDT, BTC, TRX...)',
  'fund.crypto.autoExchangeEnabled': 'Auto-Exchange Enabled',
  'fund.crypto.autoExchangeNotice': 'Your currency will be automatically converted to USDT at current market rate',

  'brand.fetchError': 'Failed to fetch brand configuration',
  'brand.saveSuccess': 'Brand configuration saved successfully',
  'brand.saveError': 'Failed to save brand configuration',
  'brand.social.saveSuccess': 'Social links saved successfully',
  'brand.social.saveError': 'Failed to save social links',
  'brand.manifest.saveSuccess': 'Manifest settings saved successfully',
  'brand.manifest.saveError': 'Failed to save manifest settings',
  'brand.noSite': 'No site selected',
  'brand.noSite.desc': 'Please select a site to manage brand and theme settings.',
  'brand.tab.design': 'Design & Assets',
  'brand.tab.social': 'Social Media',
  'brand.tab.manifest': 'PWA Manifest',
  'brand.tab.lobbies': 'Lobby Locations',
  'brand.lobby.location': 'Location (Domain)',
  'brand.lobby.maintenance': 'Maintenance',
  'brand.lobbies.add': 'Contact your manager to add lobby location',
  'brand.lobbies.add.subdomain': 'Add Subdomain Lobby',
  'brand.lobbies.required': 'Location is required',
  'brand.lobby.cname.title': 'DOMAIN',
  'brand.lobby.cname.setup': 'Setup',
  'brand.lobby.cname.step1.title': 'Log into your DNS provider',
  'brand.lobby.cname.step1.desc': 'Add the following DOMAIN record:',
  'brand.lobby.cname.name': 'Name',
  'brand.lobby.cname.target': 'Target',
  'brand.lobby.cname.step2.title': 'Save your changes',
  'brand.lobby.cname.step2.desc': 'Once you have added your records, Check DNS records to initiate a verification check.',
  'brand.lobby.cname.checkDns': 'Check DNS records',
  'brand.lobby.cname.note': 'will become automatically enabled if your records are correctly configured. DNS changes at your provider may take up to 24 hours to be updated globally.',
  'brand.logo': 'Brand Logo',
  'brand.logo.extra': 'Recommended size: 512x512px (PNG/WebP)',
  'brand.themeColor': 'Primary Theme Color',
  'brand.themeColor.desc': 'Used for buttons, highlights, and primary UI elements',
  'brand.secondaryColor': 'Secondary Theme Color',
  'brand.secondaryColor.desc': 'Subtle highlights and secondary elements',
  'brand.bgColor': 'Background Color',
  'brand.bgColor.desc': 'The main background color of the site (--bg-color)',
  'brand.surfaceColor': 'Surface Color',
  'brand.surfaceColor.desc': 'Used for cards and overlays (--surface-color)',
  'brand.textColor': 'Primary Text Color',
  'brand.textColor.desc': 'Main text color of the site (--primary-text-color)',
  'brand.bgImage': 'Background Image',
  'brand.bgImage.extra': 'URL for the background site image or mask',
  'brand.importTheme': 'Import Theme',
  'brand.exportTheme': 'Export Theme',
  'brand.save': 'Save Changes',
  'brand.facebook': 'Facebook',
  'brand.x': 'X (Twitter)',
  'brand.telegram': 'Telegram',
  'brand.whatsapp': 'WhatsApp',
  'brand.line': 'LINE',

  // Manifest
  'manifest.name': 'App Name',
  'manifest.shortName': 'Short Name',
  'manifest.shortName.desc': 'Used on the home screen when space is limited',
  'manifest.description': 'Description',
  'manifest.display': 'Display Mode',
  'manifest.orientation': 'Orientation',
  'manifest.themeColor': 'Theme Color (PWA)',
  'manifest.backgroundColor': 'Background Color (Splash)',
  'manifest.save': 'Save Manifest Settings',

  // Payment Management
  'pages.management.payment.title': 'Payment Management',
  'pages.management.payment.subTitle': 'Manage deposit and withdrawal channels',
  'pages.management.payment.table.channel': 'CHANNEL',
  'pages.management.payment.table.limits': 'LIMITS',
  'pages.management.payment.table.min': 'MIN',
  'pages.management.payment.table.max': 'MAX',
  'pages.management.payment.table.fee': 'FEE',
  'pages.management.payment.table.availability': 'AVAILABILITY',
  'pages.management.payment.table.status': 'STATUS',
  'pages.management.payment.table.accountNo': 'ACCOUNT NO',
  'pages.management.payment.table.accountName': 'ACCOUNT NAME',
  'pages.management.payment.status.online': 'SYSTEM ONLINE',
  'pages.management.payment.status.maintenance': 'MAINTENANCE',
  'pages.management.payment.message.updateSuccess': 'Status updated',
  'pages.management.payment.message.updateFailed': 'Failed to update status',
  'pages.playerFinanceOperations.filter.search': 'Search',
  'pages.playerFinanceOperations.filter.searchPlaceholder': 'REF, player, or account no.',
  'pages.playerFinanceOperations.filter.type': 'Type',
  'pages.playerFinanceOperations.filter.dateTime': 'Date/time',
  'pages.playerFinanceOperations.filter.status': 'Status',
  'pages.playerFinanceOperations.table.transaction': 'Transaction',
  'pages.playerFinanceOperations.table.note': 'Note',
  'pages.playerFinanceOperations.table.settledAt': 'Settled',
  'pages.playerFinanceOperations.type.deposit': 'Deposit',
  'pages.playerFinanceOperations.type.withdrawal': 'Withdrawal',
  'pages.playerFinanceOperations.status.pending': 'Pending review',
  'pages.playerFinanceOperations.status.settlement': 'Settling',
  'pages.playerFinanceOperations.status.succeeded': 'Succeeded',
  'pages.playerFinanceOperations.status.failed': 'Failed',
  'pages.playerFinanceOperations.status.cancelled': 'Cancelled',
  'pages.playerFinanceOperations.status.expired': 'Expired',
  // Merchant Accounts
  'pages.common.placeholder.select': 'Please select...',
  'pages.common.placeholder.input': 'Please input...',
  'pages.common.search': 'Search',
  'pages.common.submit': 'Submit',
  'pages.common.reset': 'Reset',
};
